













































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Emit, Prop } from 'vue-property-decorator'
import { forwardRef } from '@/modules/shared/helpers/utils/forwardRef'

@Component
export default class Modal extends Vue {
  @Prop({ default: '' }) readonly label!: string
  @Prop({ default: '' }) icon: string
  @Prop({ default: '900' }) readonly width!: string
  @Prop() readonly subHeader!: string
  @Prop([Boolean]) value: boolean | undefined
  @Prop({ default: true }) readonly hasCloseButton!: boolean

  @Emit('input')
  updateValue() {
  }

  mounted() {
    forwardRef(this, this.$refs.dialog)
  }
}
